//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VClamp from 'vue-clamp'

export default {
  components: {
    VClamp
  },

  props: {
    subcategory: {
      type: Object,
      required: true
    },

    basePath: {
      type: String,
      required: true
    }
  },

  computed: {
    subcategoryPath() {
      const { category, slug } = this.subcategory
      const categorySlug = category ? category.slug : 'sem-categoria'

      return this.localePath(`${this.basePath}/${categorySlug}/${slug}`)
    }
  }
}
